import React, { lazy, Suspense } from 'react';
import { Loader2 } from 'lucide-react';

// Loading component
const LoadingSpinner = () => (
  <div className="flex items-center justify-center min-h-[200px]">
    <Loader2 className="h-8 w-8 animate-spin text-primary" />
  </div>
);

// Lazy load heavy components
export const LazyStatisticViewer = lazy(() => import('../pages/StatisticViewer'));
export const LazyStatisticsList = lazy(() => import('../pages/StatisticsList'));
export const LazyNewsLayout = lazy(() => import('../pages/NewsLayout'));
export const LazyLanding = lazy(() => import('../pages/Landing'));
export const LazyMarkdownEditor = lazy(() => import('../components/MarkdownEditor'));
export const LazyImageManager = lazy(() => import('../components/ImageManager'));
export const LazyStockImageModal = lazy(() => import('../components/StockImageModal'));

// Wrapper components with Suspense
export const StatisticViewer = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyStatisticViewer {...props} />
  </Suspense>
);

export const StatisticsList = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyStatisticsList {...props} />
  </Suspense>
);

export const NewsLayout = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyNewsLayout {...props} />
  </Suspense>
);

export const Landing = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyLanding {...props} />
  </Suspense>
);

export const MarkdownEditor = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyMarkdownEditor {...props} />
  </Suspense>
);

export const ImageManager = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyImageManager {...props} />
  </Suspense>
);

export const StockImageModal = (props: any) => (
  <Suspense fallback={<LoadingSpinner />}>
    <LazyStockImageModal {...props} />
  </Suspense>
);
